import { ref, Ref } from 'vue';
import {
    FilterChangedEvent, GridApi, GridState
} from '@ag-grid-community/core';

const savedGridState: GridState = {  };

export function usePersistentFilter<TRow>(
    gridApi: Ref<GridApi<TRow> | undefined>
) {
    const initialGridState = ref(savedGridState);

    const onGridFilterChanged = (event: FilterChangedEvent<TRow>) => {
        savedGridState.filter = event.api.getState().filter;
    };

    const resetFilters = () => {
        savedGridState.filter = undefined;
        gridApi.value?.setFilterModel(null);
    };

    return {
        initialGridState,
        onGridFilterChanged,
        resetFilters
    };
}
